import { Button, type styles } from "components/Theme/button";
import type React from "react";

interface ButtonProps extends React.PropsWithChildren {
  color?: keyof typeof styles.colors;
  onClick: () => any;
  disabled: boolean;
  className?: string;
}

function NewButton(props: ButtonProps) {
  return (
    <Button
      color={props.color || "brandLight"}
      onClick={() => {
        !props.disabled && props.onClick();
      }}
      disabled={props.disabled}
      className={props.className}
    >
      {props.children}
    </Button>
  );
}

export default NewButton;
